import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { clearHashAndScrollTop, scrollPageToTop } from "../../util/scroll";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    clearHashAndScrollTop();
  }, [pathname]);

  useEffect(() => {
    const scrollTimeouts = [0, 50, 150, 400, 800].map((delay) =>
      window.setTimeout(scrollPageToTop, delay),
    );

    const handleLoad = () => scrollPageToTop();
    window.addEventListener("load", handleLoad);

    return () => {
      scrollTimeouts.forEach((timeoutId) => window.clearTimeout(timeoutId));
      window.removeEventListener("load", handleLoad);
    };
  }, [pathname]);

  return null;
};

export default ScrollToTop;
